module.exports = __webpack_public_path__ + "img/icon2@2x.534b72ed.png";